import React from "react";

import { formatPhoneNumber } from "../../Utils/helper";

function CounselSummaryView({ insurances = [] }) {
  const tableRowStyle = {
    height: "42px",
    // lineHeight: "42px",
  };

  const emptyRowStyle = {
    height: "42px",
    width: "100%",
  };

  //   const formatWithCommas = (value) => {
  //     if (!value || isNaN(Number(value))) {
  //       return "-";
  //     }
  //     return Number(value).toLocaleString();
  //   };

  const getName = (type, data = {}) => {
    if (!data) return "";
    const { first_name = "", last_name = "", entity_name = "", defendantType = "" } = data;

    const fullName = `${first_name ?? ""} ${last_name ?? ""}`?.trim();

    if (type === "Defendant") {
      return defendantType?.id === 1 ? fullName : entity_name || "";
    }

    if (type === "Client") {
      return fullName;
    }
    if (type === "Witness") {
      return `${data?.witness_first_name ?? ""} ${data?.witness_last_name ?? ""}`?.trim();
    }
    if (type === "OtherParty") {
      const fullName2 = `${data?.party_first_name ?? ""} ${data?.party_last_name ?? ""}`?.trim();
      return fullName2;
    }

    return "";
  };

  const renderDataRow = (insurance, index) => (
    <tr key={`insurance-${index}`} style={tableRowStyle}>
      {/* Index */}
      <td
        className="text-center"
        style={{
          minWidth: "25px",
          width: "25px",
          maxWidth: "25px",
          color: "var(--primary-25)",
          fontWeight: "600",
        }}
      >
        {index + 1}
      </td>

      {/* Party */}
      <td
        className="td-autosize p-l-5"
        style={{
          fontWeight: "600",
        }}
      >
        <div className="d-flex align-items-center">
          <span className="text-truncate">
            {getName(insurance?.entity_type, insurance?.entity_obj)}
          </span>
        </div>
      </td>

      <td />

      {/* Insurance */}
      <td style={{ width: "1%", fontWeight: "600" }}>
        <div className="d-flex flex-column">
          <span className="text-truncate">{insurance?.counsel_type?.name || "-"}</span>
          <span className="text-truncate">{insurance?.opposingcounselcontact?.name || "-"}</span>
        </div>
      </td>

      <td />

      {/* Adjuster */}
      <td style={{ width: "20%" }}>
        <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column"
        >
          <span className="text-truncate">
            {insurance?.opposingattorney?.first_name || insurance?.opposingattorney?.last_name
              ? `${insurance.opposingattorney.first_name || ""} ${insurance.opposingattorney.last_name || ""}`.trim()
              : ""}
          </span>
          {insurance?.opposingattorney?.phone_number && (
            <span className="text-truncate">
              {formatPhoneNumber(insurance.opposingattorney.phone_number)}
            </span>
          )}
        </div>
      </td>

      <td />

      <td
        style={{
          fontWeight: "600",
        }}
        className="text-center td-autosize"
      >
        <div>{insurance?.file_number || ""}</div>
      </td>
    </tr>
  );

  const renderEmptyRows = (dataLength) => {
    const minRows = 5;
    const emptyRowsCount = Math.max(0, minRows - dataLength);

    return Array.from({ length: emptyRowsCount }, (_, index) => (
      <tr key={`empty-${index}`} style={tableRowStyle}>
        <td colSpan={14} className="empty-row">
          <div style={emptyRowStyle}>{/* Empty row */}</div>
        </td>
      </tr>
    ));
  };

  return (
    <div className="custom-tab lit-custom-tab w-100">
      <div className="table-responsive overflow-hidden">
        <table className="table table-borderless table-striped table-treatment has-height-25">
          <thead>
            <tr id="tb-header">
              <th
                className="text-center"
                style={{
                  minWidth: "25px",
                  width: "25px",
                  maxWidth: "25px",
                }}
              >
                {/* Index */}
              </th>
              <th className="td-autosize text-center color-grey-2 p-l-5">Party</th>
              <th />

              <th className="text-center color-grey-2" style={{ width: "1%" }}>
                Law Firm
              </th>
              <th />

              <th className="text-center color-grey-2">Attorney</th>
              <th />
              <th className="text-center color-grey-2">File Number</th>
            </tr>
          </thead>
          <tbody>
            {insurances?.map((insurance, index) => renderDataRow(insurance, index))}
            {renderEmptyRows(insurances?.length || 0)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default React.memo(CounselSummaryView);
